export default __webpack_public_path__ + "167aedc.png";